<template>
  <layout :title="$route.name" :options="options">
    <div class="expande-horizontal column pa-6">
      <div class="expande-horizontal centraliza px-3 column">
        <v-avatar size="60" style="border: 3px solid #fff;">
          <v-img
            src="https://i.pinimg.com/originals/7c/c7/a6/7cc7a630624d20f7797cb4c8e93c09c1.png"
          ></v-img>
        </v-avatar>
        <h1 class="mt-3 white--text">{{ getUser.name }}</h1>
        <!-- <span class="fonte orange--text">Corretora: {{ getUser.a_id }}</span> -->
      </div>

      <div class="expande-horizontal centraliza wrap">
        <v-flex xs6 md3 class="pa-1">
          <v-card style="border-radius: 12px;" dark color="#444" class="expande-horizontal centraliza column pa-2">
            <h1 class="fonte green--text">
              {{ $helper.formataSaldo(getUser.total_value_investment.balance) }}
            </h1>
            <span class="fonte">RENTABILIDADE</span>
            <v-flex v-if="false" xs12>
              <div
                class="expande-horizontal"
                style="height: 300px; overflow: auto;"
              >
                <v-list three-line dense>
                  <template
                    v-for="(item, index) in investmentTransactions"
                  >
                    <v-list-item :key="item._id">
                      <v-list-item-content>
                        <v-list-item-title class="fonte green--text">
                          {{ $helper.formataSaldo(item.value) }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="fonte">
                          {{ item.description }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="fonte orange--text">
                          {{
                            $moment(item.created_at).format(
                              "DD/MM/YYYY [às] HH:mm"
                            )
                          }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <!-- <v-btn
                          icon
                          x-small
                          @click="
                            createConfirmAction({
                              icon: 'mdi-check',
                              message: 'Deseja remover esta transação?',
                              action: 'deleteTransaction',
                              action_value: item
                            })
                          "
                        >
                          <v-icon> mdi-delete-outline </v-icon>
                        </v-btn> -->
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider :key="index"></v-divider>
                  </template>
                </v-list>
              </div>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs6 md3 class="pa-1">
          <v-card style="border-radius: 12px;" dark color="#444" class="expande-horizontal centraliza column pa-2">
            <h1 class="fonte green--text">
              {{
                $helper.formataSaldo(getUser.total_withdraw_investment.balance * -1)
              }}
            </h1>
            <span class="fonte">SAQUES DA RENTABILIDADE </span>
            <v-flex v-if="false" xs12>
              <div
                class="expande-horizontal"
                style="height: 300px; overflow: auto;"
              >
                <v-list three-line dense>
                  <template
                    v-for="(item, index) in getUser.total_withdraw_investment
                      .extract"
                  >
                    <v-list-item :key="item._id">
                      <v-list-item-content>
                        <v-list-item-title class="fonte green--text">
                          {{ $helper.formataSaldo(item.value) }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="fonte">
                          {{ item.description }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="fonte orange--text">
                          {{
                            $moment(item.created_at).format(
                              "DD/MM/YYYY [às] HH:mm"
                            )
                          }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="index"></v-divider>
                  </template>
                </v-list>
              </div>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex v-if="false" xs12 md3 class="pa-1">
          <v-card class="expande-horizontal centraliza column pa-2">
            <h1 class="fonte green--text">
              {{ $helper.formataSaldo(getUser.total_value_unilevel.balance) }}
            </h1>
            <span class="fonte">UNILEVEL</span>
            <v-flex xs12>
              <div
                class="expande-horizontal"
                style="height: 300px; overflow: auto;"
              >
                <v-list three-line dense>
                  <template
                    v-for="(item, index) in getUser.total_value_unilevel
                      .extract"
                  >
                    <v-list-item :key="item._id">
                      <v-list-item-content>
                        <v-list-item-title class="fonte green--text">
                          {{ $helper.formataSaldo(item.value) }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="fonte">
                          {{ item.description }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="fonte orange--text">
                          {{
                            $moment(item.created_at).format(
                              "DD/MM/YYYY [às] HH:mm"
                            )
                          }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="index"></v-divider>
                  </template>
                </v-list>
              </div>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex v-if="false" xs12 md3 class="pa-1">
          <v-card class="expande-horizontal centraliza column pa-2">
            <h1 class="fonte green--text">
              {{
                $helper.formataSaldo(getUser.total_withdraw_unilevel.balance)
              }}
            </h1>
            <span class="fonte">SAQUES DO UNILEVEL</span>
            <v-flex xs12>
              <div
                class="expande-horizontal"
                style="height: 300px; overflow: auto;"
              >
                <v-list three-line dense>
                  <template
                    v-for="(item, index) in getUser.total_withdraw_unilevel
                      .extract"
                  >
                    <v-list-item :key="item._id">
                      <v-list-item-content>
                        <v-list-item-title class="fonte green--text">
                          {{ $helper.formataSaldo(item.value) }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="fonte">
                          {{ item.description }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="fonte orange--text">
                          {{
                            $moment(item.created_at).format(
                              "DD/MM/YYYY [às] HH:mm"
                            )
                          }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          icon
                          x-small
                          @click="
                            createConfirmAction({
                              icon: 'mdi-check',
                              message: 'Deseja remover esta transação?',
                              action: 'deleteTransaction',
                              action_value: item
                            })
                          "
                        >
                          <v-icon> mdi-delete-outline </v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider :key="index"></v-divider>
                  </template>
                </v-list>
              </div>
            </v-flex>
          </v-card>
        </v-flex>
      </div>
      <v-flex xs12 class="px-3 mt-3">
        <v-tabs centered style="border-radius: 12px;" v-model="tabs" dark color="orange" background-color="#444" class="fonte">
          <v-tab>Informações do Investidor</v-tab>
          <v-tab>Compras</v-tab>
          <v-tab>Progresso dos Planos</v-tab>
          <v-tab>Extratos</v-tab>
        </v-tabs>
      </v-flex>
      
      <div v-if="tabs === 0" class="expande-horizontal wrap mt-6 pa-3">
        <v-flex class="pr-2" xs12 md3>
          <span class="fonte orange--text"> Nome</span>
          <v-text-field
            solo-inverted
            dark
            flat
            dense
            :color="$theme.primary"
            label="Nome"
            v-model="getUser.name"
          ></v-text-field>
        </v-flex>
        <v-flex class="pr-2" xs12 md2>
          <span class="fonte orange--text"> CPF</span>
          <v-text-field
            solo-inverted
            dark
            readonly
            flat
            dense
            :color="$theme.primary"
            label="Login"
            v-model="getUser.cpf"
          ></v-text-field>
        </v-flex>
        <v-flex class="pr-1" xs12 md2>
          <span class="fonte orange--text"> Login</span>
          <v-text-field
            solo-inverted
            dark
            flat
            dense
            :color="$theme.primary"
            label="Login"
            readonly
            v-model="getUser.nickname"
          ></v-text-field>
        </v-flex>
        <v-flex class="px-1" xs12 md3>
          <span class="fonte orange--text"> E-mail</span>
          <v-text-field
            solo-inverted
            dark
            flat
            readonly
            dense
            :color="$theme.primary"
            label="Email"
            v-model="getUser.email"
          ></v-text-field>
        </v-flex>
        <v-flex class="px-1" xs12 md2>
          <span class="fonte orange--text"> Contato</span>
          <v-text-field
            solo-inverted
            dark
            flat
            dense
            :color="$theme.primary"
            label="Contato"
            v-model="getUser.phone"
            v-mask="['(##) # ####-####']"
          ></v-text-field>
        </v-flex>
      </div>

      <div v-if="tabs === 1" class="expande-horizontal wrap mt-6">
        <template v-for="purchase in getPurchases">
          <PurchaseCareer
            :key="purchase.item._id"
            :purchase="purchase"
            v-if="purchase.purchase_type === 'career'"
          />
          <PurchaseInvestment
            :key="purchase.item._id"
            :purchase="purchase"
            v-if="purchase.purchase_type === 'investment'"
          />
          <PurchaseProduct
            :key="purchase.item._id"
            :purchase="purchase"
            v-if="purchase.purchase_type === 'product'"
          />
        </template>
      </div>

      <!-- progresso dos planos -->
      <div v-if="tabs == 2" class="expande-horizontal wrap">
        <v-flex
        class="pa-3 animate__animated animate__fadeIn animate__delay-2s"
        v-for="purchase in getPurchases"
        v-show="purchase.purchase_type == 'investment'"
        :key="purchase._id"
        xs12 md4
      >
        <v-card dark style="border-radius: 12px;" color="#333">
          <v-flex xs12>
            <div class="expande-horizontal wrap column">
              <div class="expande-horizontal pa-2">
                <span style="font-size: 14pt;" class="font-weight-bold white--text px-2">
                  <!-- {{ purchase.item.title }} -->
                  {{ purchase.item.description }}</span
                >
                <v-spacer></v-spacer>
                
                <v-btn
                  dark
                  class="elevation-0"
                  :color="getColorByPurchaseProgress(purchase)"
                  x-small
                >
                  <span class="fonte-bold">
                    {{
                      purchase.current_status === "active"
                        ? ""
                        : purchase.current_status
                    }}
                  </span>
                  <span class="fonte-bold" v-if="purchase.total_percent_gained">
                    {{ parseFloat(purchase.total_percent_gained) }} de
                    {{ purchase.item.total_percent_gain }}%
                  </span>
                </v-btn>
              </div>
              <div class="my-2 expande-horizontal centraliza" v-if="purchase.item.restant_cicles">
                <v-chip style="border-radius: 6px;" color="green" class="fonte px-1 mr-1" v-for="n in (12 - purchase.item.restant_cicles)" :key="n">
                  {{ n }}
                  <v-icon>mdi-check-all</v-icon>
                </v-chip>
                <v-chip style="border-radius: 6px;" :outlined="i === 0 ? false : true" :color="i === 0 ? 'blue' : 'grey darken-1'" :dark="i === 0 ? false : true" class="px-1 fonte mr-1" v-for="(n, i) in purchase.item.restant_cicles" :key="n">
                  {{ n + (12 - purchase.item.restant_cicles) }}
                  <v-icon v-if="i === 0">mdi-check</v-icon>
                  <v-icon v-else>mdi-clock-outline</v-icon>
                </v-chip>
              </div>
              <div class="expande-horizontal" style="background: #444; padding: 3px;">
                <v-progress-linear
                  :color="getColorByPurchaseProgress(purchase)"
                  height="15"
                  style="border-radius: 56px;"
                  stream
                  :value="purchase.total_percent_gained / 2.4"
                  :buffer-value="purchase.total_percent_gained / 2.4"
                  striped
                >
                  <template v-slot:default="{ value }">
                    <span class="white--text font-weight-bold"
                      >{{ parseFloat(purchase.total_percent_gained) }} de
                      {{ purchase.item.total_percent_gain }}%</span
                    >
                  </template>
                </v-progress-linear>
              </div>
              <!-- <div class="pa-3 pb-1 pt-0 expande-horizontal">
                <v-icon class="mr-1" color="orange" size="11">mdi-star</v-icon>
                <span style="font-size: 9pt;;" class="fonte orange--text">
                  Dia de saque: {{ $moment(purchase.due_date).format("DD") }} +
                  3 dias subsequentes
                </span>
              </div> -->
              <div class="pa-3 px-0 pb-1 pt-0 expande-horizontal">
                <v-timeline dense class="px-0">
                  <v-timeline-item
                    :color="status.color"
                    small
                    v-for="status in purchase.status"
                    :key="status"
                  > 
                    <span class="fonte"> {{ status.status }}</span>
                    <span class="grey--text fonte"> ({{ $moment(status.date).format('DD/MM/YYYY [às] HH:mm') }}) </span>
                  </v-timeline-item>
                  <v-timeline-item
                    v-if="purchase.item && purchase.item.next_reset_circle"
                    color="green"
                    icon="mdi-flag-outline"
                  >
                    <div class="pt-2">
                      <span class="fonte mt-3 pt-3">Próximo Resgate - </span>=
                      <span class="grey--text fonte"> {{ $moment(purchase.item.next_reset_circle).format('DD/MM/YYYY') }} </span>
                    </div>
                    <!-- <v-avatar><v-icon color="green">mdi-flag-outline</v-icon></v-avatar> -->
                  </v-timeline-item>
                  <!-- <v-timeline-item
                    v-if="purchase.item && purchase.item.restant_cicles"
                    color="orange"
                    icon="mdi-information-outline"
                  >
                    <div class="pt-2 expande-horizontal column">
                      <span class="fonte mt-3 pt-3">Ciclos Restantes ({{ purchase.receive_type }}) </span>
                      <span class="grey--text fonte"> {{ purchase.item.restant_cicles - 1 }} </span>
                    </div>
                  </v-timeline-item> -->
                  <v-timeline-item
                    v-if="purchase.item && !purchase.item.restant_cicles"
                    color="orange"
                    icon="mdi-information-outline"
                  >
                    <div class="pt-2 expande-horizontal column">
                      <span class="fonte mt-3 pt-3">Tipo de Recebimento ({{ purchase.receive_type }}) </span>
                      <span class="grey--text fonte" v-if="purchase.receive_type == 'mensal'"> por 12 meses </span>
                    </div>
                  </v-timeline-item>
                </v-timeline>
                <!-- <span
                  style="font-size: 18pt;"
                  class="my-4 font-weight-bold green--text"
                >
                  Saldo: R$
                  {{ $toLocaleString(purchase.withdraw_available_value || 0) }}
                </span> -->
              </div>
              <!-- <div class="pa-3 pb-1 pt-0 expande-horizontal">
                <span style="font-size: 9pt;;" class="fonte red--text">
                  Saques: R$
                  {{ $toLocaleString(purchase.withdraw_available_fired || 0) }}
                </span>
              </div> -->
            </div>
          </v-flex>
        </v-card>
      </v-flex>
      </div>

      <div v-if="tabs == 3" class="expande-horizontal wrap mt-6">
        <v-flex xs12 class="pa-6 pt-3">
          <v-simple-table
            dense
            style="width: 100%;"
            v-if="getTransactions.length > 0"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Valor</th>
                  <th>Descrição</th>
                  <th>Data</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  style="cursor: pointer"
                  @click="abreNotificacao(item)"
                  v-for="item in getTransactions"
                  :key="item.uid"
                >
                  <td class="font-weight-bold fonteCorpo green--text">
                    {{ $helper.formataSaldo(item.value) }}
                  </td>
                  <td class="font-weight-bold fonteCorpo">
                    {{ item.description }}
                  </td>
                  <td class="font-weight-bold grey--text fonteCorpo">
                    {{
                      $moment(item.created_at)
                        .locale("pt-br")
                        .format("llll")
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <Empty v-else></Empty>
        </v-flex>
      </div>

      <div v-if="false" class="expande-horizontal wrap mt-6">
        <v-flex xs12>
          <h1 class="fonte grey--text pa-7">
            # Rede - {{ getUser.rede.length }}
          </h1>
        </v-flex>
        <v-flex xs12 class="pa-6 pt-3">
          <v-list class="pa-0" dark v-if="getUser.rede.length > 0">
            <template v-for="(item, index) in getUser.rede">
              <v-list-item :key="item._id">
                <v-avatar>
                  <v-icon>mdi-account-circle</v-icon>
                </v-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.indicated_name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.indicated_phone }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="fonte orange--text">
                    Desde
                    {{
                      $moment(item.created_at).format("DD/MM/YYYY [às] HH:mm")
                    }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="index"></v-divider>
            </template>
          </v-list>

          <Empty v-else></Empty>
        </v-flex>
      </div>
      <ModalAddBalance />
      <ModalUpdatePass />
    </div>
  </layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PurchaseCareer from "@/apps/11#purchases/components/PurchaseCareer";
import PurchaseInvestment from "@/apps/11#purchases/components/PurchaseInvestment";
import PurchaseProduct from "@/apps/11#purchases/components/PurchaseProduct";
import ModalAddBalance from "@/apps/2#users/components/modalAddBalance";
import ModalUpdatePass from "@/apps/2#users/components/modalUpdatePass";

export default {
  props: ["id"],
  components: {
    PurchaseCareer,
    PurchaseInvestment,
    PurchaseProduct,
    ModalAddBalance,
    ModalUpdatePass
  },
  data() {
    return {
      tabs: 0,
      options: [
        // {
        //   nome: "Ativar Rede",
        //   action: () => this.enableUnilevel()
        // },
        // {
        //   nome: "Desativar Rede",
        //   action: () => this.disableUnilevel()
        // },
        {
          nome: "Salvar Alterações",
          action: () => this.updateUser()
        },
        // {
        //   nome: "Add Saldo",
        //   action: () => this.abreModalAddBalance()
        // },
        {
          nome: "Bloquear",
          action: () => this.blockUser()
        },
        {
          nome: "Desbloquear",
          action: () => this.unblockUser()
        },
        {
          nome: "Atualizar Senha",
          action: () => this.abreModalUpdatePass()
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getUser", "getPurchases", "getTransactions"]),
    investmentTransactions() {
      if (!this.getTransactions.length) return [];
      const regs = this.getTransactions.filter(item => item.transaction_type === "investment" && item.current_status == 'active');
      return regs;
    },
  },
  methods: {
    ...mapActions([
      "viewUser",
      "createConfirmAction",
      "enableUnilevel",
      "disableUnilevel",
      "updateUser",
      "abreModalAddBalance",
      "blockUser",
      "unblockUser",
      "abreModalUpdatePass",
      "deleteTransaction"
    ]),
    getColorByPurchaseProgress(purchase) {
      if (purchase.total_percent_gained === purchase.item.total_percent_gain) {
        return "orange";
      }

      if (
        purchase.total_percent_gained &&
        purchase.total_percent_gained < purchase.item.total_percent_gain
      ) {
        return "green";
      }

      if (purchase.total_percent_gained === 0) {
        return "red";
      }
    }
  },
  created() {
    this.viewUser({ _id: this.id });
  }
};
</script>
